import FlightDatesHelper from '../../modules/flight_dates_helper.js';

angular.module('vastdesk').
  component('demandTagCampaign',  {
    bindings: {
      formName: '@',
      formId: '@'
    },
    template: require("../templates/demandTagCampaign.html"),
    controllerAs: '$demandTagCampaignCtrl',
    controller: ["$scope","$timeout",'$rootScope', function($scope, $timeout, $rootScope) {

      const timezone = 'Etc/UTC';
      const flightDatesHelper = new FlightDatesHelper();

      $scope.isInactiveFlight = false;
      $scope.campaignId = null;

      this.inactiveFlight = function () {
        return $scope.isInactiveFlight;
      };

      $scope.$on("campaignChanged", (e, args) => {
        // if this is a new campaign from the one we have dates for,
        // clear the isInactiveFlight flag and wait for the new campaign to be loaded
        if (args.campaignId !== $scope.campaignId) {
          $scope.campaignId = args.campaignId;
          $scope.isInactiveFlight = false;
          $timeout(function () {
            $scope.$apply();
          });
        }
      });

      $rootScope.$on("campaignDatesChange", (e, campaign) => {
        if (!campaign) {
          $scope.isInactiveFlight = false;
          $scope.campaignId = null;
        } else {
          $scope.campaignId = campaign.id;

          $scope.isInactiveFlight =
            flightDatesHelper.pastEndDate(
              campaign.targeting_time_profile &&
                campaign.targeting_time_profile.end_date,
              timezone
            ) ||
            flightDatesHelper.inactiveByBudgetFlightDates(
              campaign.targeting_spend_profile &&
                campaign.targeting_spend_profile.budgets
            );
        }
        $scope.$apply();
      });
    },
  ],
});
